var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":!_vm.parent.forward?_vm.parent.vertical?'fade-tab-vertical-invert':'fade-tab-invert':_vm.parent.vertical?'fade-tab-vertical':'fade-tab'}},[_c('keep-alive',[(_vm.active)?_c('KeepSlot',{key:_vm.uid,staticClass:"con-tab vs-tabs--content"},[_vm._t("default")],2):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }